exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-voice-runner-js": () => import("./../../../src/pages/projects/voice-runner.js" /* webpackChunkName: "component---src-pages-projects-voice-runner-js" */),
  "component---src-templates-article-js": () => import("./../../../src/templates/article.js" /* webpackChunkName: "component---src-templates-article-js" */),
  "component---src-templates-now-js": () => import("./../../../src/templates/now.js" /* webpackChunkName: "component---src-templates-now-js" */)
}

